class ConversationDetailsController {
    constructor(moment, UserDetailsApi, ReportUtilityServiceApi, ReportServiceApi, SettingsService, ngProgressFactory, UtpAttachmentServiceApi) {
        this.$onChanges = function (changes) {
            if (!changes) {
                return;
            }
            if (changes.note) {
                this.note = changes.note.currentValue;
            }
        };
        this.getReport = () => {
            this.traceProgress.start();
            this.UtpAttachmentServiceApi.getConversationById(this.state.reportRequest).then((noteResponse) => {
                this.traceProgress.complete();
                this.data.notes = this.ReportService.adjustToLocalTime(noteResponse.data, this.state.UserDetails.TimezoneOffset);
            });
        };
        this.isToday = (dt) => {
            let today = this.moment();
            return today.diff(dt, 'days') === 0;
        };
        this.getFromNowString = (note) => {
            // When there's a timezoneOffset TimestampPrevious is set (see report-utility.service.ts:adjustToLocalTime())
            // In this case note.Timestamp gets modified to accomodate the offset but it also gets it format changed.
            // note.TimestampPrevious is kept as the "clean" server timestamp
            let time = '';
            if (note.TimestampPrevious) {
                time = note.TimestampPrevious;
            }
            else {
                time = note.Timestamp;
            }
            let local = this.moment(time, 'YYYY-MM-DDTHH:mm:ss.S' // YYYY-MM-DDTHH:mm:ss.S - utcTime format
            ).local();
            return this.moment(local).fromNow();
        };
        this.sortIntoConversations = () => {
            let notes = this.data.notes;
            // @ts-ignore lodash
            const conversations = _.uniqBy(notes, (item) => {
                return item.ConversationID;
            });
            this.data.conversations = _.map(conversations, (item) => {
                return {
                    Id: item.ConversationID,
                    // Sim: item.SimId,
                    // Suite: item.SuiteId,
                    // Test: item.TestId,
                    // User: item.UserId,
                    notes: {},
                    show: true
                };
            });
            for (let i = 0; i < conversations.length; i++) {
                this.data.conversations[i].notes = _.filter(notes, (item) => {
                    return item.ConversationID === this.data.conversations[i].Id;
                });
            }
        };
        this.moment = moment;
        this.UserDetailsApi = UserDetailsApi;
        this.ReportService = ReportUtilityServiceApi;
        this.ReportServiceApi = ReportServiceApi;
        this.SettingsService = SettingsService;
        this.ngProgressFactory = ngProgressFactory;
        this.UtpAttachmentServiceApi = UtpAttachmentServiceApi;
    }
    $onInit() {
        this.state = {
            showSelectors: false,
            traceAlternateView: true,
            moreOk: true,
            showReport: false,
            UserDetails: {},
            reportRequest: {
                SimId: 0,
                TestId: 0,
                UserId: 0,
                SuiteId: 0,
                TraceId: this.note.Id,
                CreatedBy: 0,
                TraceUid: '',
                Contains: '',
                ConversationId: this.note.ConversationID,
                FromDate: null, // Get the js date object behind the moment for Datepicker to parse correctly
                ToDate: null,
                ProjectIterationId: 0,
                FuzzyConversationId: false
            }
        };
        this.traceProgress = this.ngProgressFactory.createInstance();
        // console.log(note);
        this.data = {
            notes: {},
            conversations: {}
        };
        this.fromDateOptions = {
            formatYear: 'yy',
            startingDay: 1,
            minDate: null,
            maxDate: moment().toDate()
        };
        this.toDateOptions = {
            formatYear: 'yy',
            startingDay: 1,
            minDate: this.state.reportRequest.FromDate,
            maxDate: moment().toDate()
        };
        // this.note = this.resolve.note;
        this.traceProgress.start();
        this.SettingsService.getSettings().then((response) => {
            let appSettings = response.data;
            this.state.showReport = true;
        });
        this.UserDetailsApi.get().then((userResponse) => {
            this.state.UserDetails = userResponse.data; // setup our user details
            this.UtpAttachmentServiceApi.getConversationById(this.state.reportRequest).then((noteResponse) => {
                this.traceProgress.complete();
                // console.log(note_response.data);
                this.data.notes = this.ReportService.adjustToLocalTime(noteResponse.data, this.state.UserDetails.TimezoneOffset);
                this.sortIntoConversations();
            });
        });
    }
}
angular.module('app').component('conversationDetailsComponent', {
    bindings: {
        note: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/Reports/conversation-details.tpl.html',
    controllerAs: 'vm',
    controller: ConversationDetailsController
});
